import { useOptimisedImages } from '@navi-toolbox/hooks';
import { LinkButton } from 'fronton-react';
import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ImagePlaceholder, ImageFallback } from '@navi-toolbox/ui-components';
import { analyticsUtils } from 'utils';
import { BrandWord } from './brand-word';
import {
  brandLinkItem,
  otherProductsImageWrapper,
  image,
  brandLinkContainer,
  brandWordAbsolute,
} from '../styles';

type BrandLinkProps = {
  label: string;
  link: string;
  type: 'brand' | 'category';
  imageUrl?: string;
};

export const BrandLink: FC<BrandLinkProps> = ({ label, link, type, imageUrl }) => {
  const { t } = useTranslation();

  const imageSize = {
    h: '48',
    w: '48',
  };

  const optimizedImage = useOptimisedImages({
    src: imageUrl,
    sizes: {
      restImage: imageSize,
    },
  });

  const typeLabel = type === 'brand' ? t('other-products.brand', { brand: label }) : label;

  const shouldRenderBrandWord = type === 'brand' && !imageUrl;
  const shouldRenderFallback = type === 'category' && !imageUrl;
  const shouldRenderImage = !shouldRenderBrandWord && !shouldRenderFallback;

  const sendAnalytics = useCallback(() => {
    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementBlock: 'productDetail',
      elementName: 'otherProducts',
      elementText: typeLabel,
      elementLink: link,
    });
  }, [link, typeLabel]);

  return (
    <div className={brandLinkContainer}>
      {shouldRenderBrandWord && (
        <div className={brandWordAbsolute}>
          <BrandWord brandName={label} />
        </div>
      )}

      <LinkButton onClick={sendAnalytics} className={brandLinkItem} href={link}>
        <div className={otherProductsImageWrapper}>
          {shouldRenderFallback && (
            <ImageFallback
              alt={t('ui.image.alt')}
              width={Number(imageSize.w)}
              height={Number(imageSize.h)}
              aria-hidden="true"
            />
          )}

          {shouldRenderImage && (
            <ImagePlaceholder
              className={image}
              src={optimizedImage.restImage?.x || ''}
              srcSet={`${optimizedImage.restImage?.xx} 2x, ${optimizedImage.restImage?.x} 1x`}
              alt={`Изображение ${label}`}
              fallbackAlt={t('ui.image.alt')}
              title={label}
              width={Number(imageSize.w)}
              height={Number(imageSize.h)}
              fallbackWidth={Number(imageSize.w)}
              fallbackHeight={Number(imageSize.h)}
              loading="lazy"
            />
          )}
        </div>
        <span>{typeLabel}</span>
      </LinkButton>
    </div>
  );
};
